export const environment = {
  production: true,
  defaultauth: 'znobackend',
  urlAddress: 'https://api-v2.sarraf.io/api',
  aiUrlAddress: 'https://api-v2.sarraf.io/api/ai',
  baseUrlAddress: 'https://api-v2.sarraf.io',
  gatewayAddress: 'https://api-v2.sarraf.io/api',
  marketPlaceGeneralAddress: 'https://api.sarrafcarsi.com/api/general',
  marketplaceIntegrationAddress: 'https://api.sarrafcarsi.com/api/integration',
  marketPlaceOrderAddress: 'https://api.sarrafcarsi.com/api/order',
  marketPlaceProductAddress: 'https://api.sarrafcarsi.com/api/product',
  marketPlaceAIAddress: 'https://api.sarrafcarsi.com/api/ai',
  // urlAddress: 'https://api-uat.sarraf.io/api',
  // baseUrlAddress: 'https://api-uat.sarraf.io',
  // Modern tema VARSAYILAN. false = acil durum anahtari: herkes klasik temaya
  // doner ve gecis kontrolu gizlenir.
  newDesignEnabled: true,
  version: "3.7.0",
  tokenPaymentBankInfo: {
    bankName: 'Kuveyt Türk Katılım Bankası A.Ş.',
    iban: 'TR42 0020 5000 0977 4461 9000 01',
    accountHolder: 'Osman Tuğrul Orhan'
  }
};
